"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersSelectButton = function (_a) {
    var isOpened = _a.isOpened, onClick = _a.onClick, _b = _a.labelKey, labelKey = _b === void 0 ? 'translation.provider' : _b;
    var t = (0, next_intl_1.useTranslations)();
    return (react_1.default.createElement("button", { className: styles_module_scss_1.default.selectButton, onClick: onClick },
        react_1.default.createElement("span", null, t(labelKey)),
        react_1.default.createElement(image_1.default, { className: "".concat(styles_module_scss_1.default.iconImg, " ").concat(isOpened ? styles_module_scss_1.default.openedIconImg : ''), width: "14", height: "13", src: "/img/icons/arrow.svg", alt: "Arrow Icon" })));
};
exports.default = (0, react_1.memo)(ProvidersSelectButton);
